import React from 'react'
import type { RouteObject } from 'react-router-dom'

export const pageRoute: RouteObject = {
    path: 'page',
    element: <React.Fragment />
}
